// Update the import path below to the correct location of Mapper, for example:

import { Mapper } from '../../../core/base/utils/mapper';
import { TenantConfiguration } from '../../../core/domain/models/tenant-configuration-model';
import { TenantConfigurationWebEntity } from './tenant-configurations.web-entity';

export class TenantConfigurationWebRepositoryMapper extends Mapper<
  TenantConfigurationWebEntity,
  TenantConfiguration
> {
  mapFrom(param: TenantConfigurationWebEntity): TenantConfiguration {
    return {
      name: param.name,
      isEnabled: param.isEnabled,
      value: param.value,
    };
  }

  mapTo(param: TenantConfiguration): TenantConfigurationWebEntity {
    return {
      name: param.name,
      isEnabled: param.isEnabled,
      value: param.value,
    };
  }
}
